import * as React from "react";
/* istanbul ignore next */
export class Cta extends React.Component {
    /* istanbul ignore next */
    render() {
        let selected = this.props.selected ? true : false;
        return (React.createElement("a", { href: "javascript:;", "data-selected": selected, className: "racing-region-selector__label" }, this.props.label));
    }
}
//# sourceMappingURL=Cta.js.map